import styled from '@emotion/styled';

/**
 * CollectiveStoryPage — Page 6 of the Kuutio print report.
 *
 * "Kollektiivinen tulevaisuustarina" — subtitle + italic heading + body text left, image right.
 * All positions from IDML Spread_u4606.xml via idml-to-css.mjs.
 *
 * Elements:
 *   u46a2: Title at left:42.5pt top:32.6pt (Pikkuotsikko: Book Italic 18pt)
 *   u46c2: Subtitle at left:42.5pt top:102pt (italic heading)
 *   u4642: Body text at left:42.5pt top:158.7pt w:335.9pt (Leipis 11pt/13pt)
 *   u7a46: Image at left:409.6pt top:77.2pt w:403.9pt h:453.6pt (tki-rahoitushaku2_2.jpg)
 */
export default function CollectiveStoryPage({
  instanceNumber = '3',
  topic = 'Kansainvälisten opiskelijoiden työllistyminen Suomeen',
}) {
  return (
    <Page className="page">
      {/* Pikkuotsikko style: Book Italic 18pt */}
      <SubTitle>Kollektiivinen tulevaisuustarina toivotusta tulevaisuudesta</SubTitle>
      <YellowRule />

      {/* Italic heading */}
      <ItalicHeading>
        Suomi, jossa muutokset{'\n'}ovat toteutuneet
      </ItalicHeading>

      {/* Body text */}
      <BodyFrame>
        <Body>
          Tavoittelemamme tulevaisuuden Suomi on avoin ja kansainvälinen
          maa, jossa ihmisen tausta ei määritä hänen asemaansa, vaan jokainen
          nähdään yhdenvertaisena yhteiskunnan jäsenenä. Suomi ja kansainvä­liset
          osaajat ovat sitoutuneita toisiinsa, ja ilmapiiriä leimaa kunnioitta­va
          uteliaisuus ja vahva luottamus.
        </Body>
        <Body>
          Yhteiskunnallinen keskustelu ja poliittiset linjaukset korostavat yhte­näisyyttä
          ja maahanmuuttajien kokonaisvaltaista näkemistä. Kansain­väliset
          osaajat osallistuvat aktiivisesti päätöksentekoon ja palveluiden
          kehittämiseen, murtavat vanhoja rajoja ja rakentavat uusia yhteisiä
          rakenteita.
        </Body>
        <Body>
          Työelämässä inklusiivisuus ja potentiaalin tunnistaminen ovat arkea.
          Työnantajat hyödyntävät antirasistisia rekrytointimenetelmiä ja palk­kaavat
          henkilöitä rohkeasti, vaikka kielitaito olisi vielä kehittymässä.
          Työtehtäviä mukautetaan osaamisen mukaan, ja työyhteisöt tukevat
          suomen kielen oppimista esimerkiksi mentoroinnin avulla.
        </Body>
        <Body>
          Korkeakoulutetut työllistyvät koulutustaan vastaaviin tehtäviin, ja
          uran alkuvaiheen mahdollisuudet ovat parantuneet. Englannin kielen
          rooli työelämässä on kasvanut, ja vuorovaikutus eri taustaisten ihmis­ten
          välillä on keskiössä.
        </Body>
        <Body>
          Lopputuloksena on monimuotoisuutta arvostava yhteiskunta, jossa
          jokaisella on mahdollisuus elää turvallista ja tasapainoista elämää
          ilman rajoja.
        </Body>
      </BodyFrame>

      {/* Right image */}
      <ImageFrame>
        <img src="/assets/report/tki-rahoitushaku2_2.jpg" alt="Tulevaisuus" />
      </ImageFrame>

      <PageFooter>
        <FooterLeft><strong>Kuutio #{instanceNumber}:</strong> {topic}</FooterLeft>
        <FooterRight>6</FooterRight>
      </PageFooter>
    </Page>
  );
}

const Page = styled.div`
  width: 297mm;
  min-height: 210mm;
  background: #fff;
  color: #000;
  position: relative;
  font-family: 'Rational', sans-serif;
  box-sizing: border-box;
  overflow: hidden;
  @media print { break-after: page; }
`;

const SubTitle = styled.h2`
  position: absolute;
  left: 42.5pt;
  top: 32.6pt;
  width: 552.8pt;
  font-size: 18pt;
  font-weight: 400;
  font-style: italic;
  margin: 0;
`;

const YellowRule = styled.div`
  position: absolute;
  left: 42.5pt;
  top: 56pt;
  width: calc(297mm - 42.5pt - 28.3pt);
  height: 3pt;
  background: #FBE300;
`;

const ItalicHeading = styled.h3`
  position: absolute;
  left: 42.5pt;
  top: 102.0pt;
  width: 211.9pt;
  font-size: 18pt;
  font-weight: 400;
  font-style: italic;
  line-height: 22pt;
  margin: 0;
  white-space: pre-line;
`;

const BodyFrame = styled.div`
  position: absolute;
  left: 42.5pt;
  top: 158.7pt;
  width: 335.9pt;
`;

const Body = styled.p`
  font-size: 11pt;
  font-weight: 400;
  line-height: 13pt;
  margin: 0 0 10pt 0;
`;

const ImageFrame = styled.div`
  position: absolute;
  left: 409.6pt;
  top: 77.2pt;
  width: 403.9pt;
  height: 453.6pt;
  overflow: hidden;
  img { width: 100%; height: 100%; object-fit: cover; }
`;

const PageFooter = styled.div`
  position: absolute;
  bottom: 14pt;
  left: 42.5pt;
  right: 28.3pt;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 0.5pt solid rgba(0, 0, 0, 0.3);
  padding-top: 6pt;
`;
const FooterLeft = styled.span` font-size: 8pt; font-style: italic; `;
const FooterRight = styled.span` font-size: 10pt; `;
